import { DropdownEntry } from "./types";

import { V1AlphaService, Scheme, Grade, Period, OpenAPI } from "./api-client";
import { DropdownIdentifier } from "./constants";

OpenAPI.BASE = (window as any).API_BASE_URL || '';

export const fetchRatesAndBrackets = async (scheme: string, period: string) => {
  if (!scheme || !period) {
    throw new Error('Scheme and period are required');
  }

  return V1AlphaService.v1AlphaRatesAndBracketsRetrieve(period, scheme)
};

export const fetchDropdownEntries = async <TEntry extends DropdownEntry>(
  dropdownIdentifier: DropdownIdentifier
): Promise<TEntry[]> => {
  let res: TEntry[] = [];
  switch(dropdownIdentifier){
    case DropdownIdentifier.Scheme:
      const schemes: Scheme[] = await V1AlphaService.v1AlphaSchemesList();
      res = schemes as TEntry[]
      break
    case DropdownIdentifier.Grade:
      const grades: Grade[] = await V1AlphaService.v1AlphaGradesList();
      res = grades as TEntry[]
      break
    case DropdownIdentifier.Period:
      const periods: Period[] = await V1AlphaService.v1AlphaPeriodsList();
      res = periods as TEntry[]
      break
  }
  return res;
};

export const fetchSalaryData = async (scheme: string, period: string, grade: string) => {
  if (!scheme || !period || !grade) {
    throw new Error('Scheme, period, and grade are required');
  }

  return V1AlphaService.v1AlphaSalariesList(grade, period, scheme);
};
